var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Icon24PxTax(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "4-icon-24-px-tax"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    className: "\\xF0\\x9F\\x8E\\xA8 Color"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.5 3A2.5 2.5 0 0121 5.5V12a1 1 0 01-1 1h-2v5.544a2 2 0 01-1.85 1.994l-.15.006a2 2 0 01-.718-.133L10.5 18.57l-4.782 1.84a2 2 0 01-2.523-1.005l-.062-.144A2 2 0 013 18.544V6a3 3 0 013-3h12.5zM16 5H6a1 1 0 00-1 1v12.544l5.141-1.977a1 1 0 01.718 0L16 18.544V5zm2.5 0a.5.5 0 00-.5.5V11h1V5.5a.5.5 0 00-.41-.492L18.5 5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 8a1 1 0 011-1h5a1 1 0 110 2H8a1 1 0 01-1-1zM7 11a1 1 0 011-1h5a1 1 0 110 2H8a1 1 0 01-1-1zM7 14a1 1 0 011-1h3a1 1 0 110 2H8a1 1 0 01-1-1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Icon24PxTax);
export default __webpack_public_path__ + "static/media/4-icon-24-px-tax.6e7cef16.svg";
export { ForwardRef as ReactComponent };